import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import config from '../../config';
import WelcomePage from './WelcomePage';
import PersonalInfoPage from './PersonalInfoPage';
import FitnessGoalPage from './FitnessGoalPage';
import StartPointPage from './StartPointPage';
import TargetPointPage from './TargetPointPage';
import SummaryPage from './SummaryPage';
import '../../scss/components/onboarding.scss';

const OnboardingFlow = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const telegramId = useSelector((state) => state.user.telegramId);

    // Состояние для хранения данных пользователя
    const [userData, setUserData] = useState({
        name: "",
        birthDate: "",
        gender: "",
        goal1: "", // род деятельности
        goal2: "", // фитнес цель
        aboutMe: "",
        financialGoal: "",
        startPoint: {
            weight: 70,
            assets: "",
            income: "",
            condition: 5
        },
        targetPoint: {
            weight: 70,
            assets: "",
            income: "",
            condition: 5
        }
    });

    // Обработчик для обновления данных пользователя
    const updateUserData = (field, value) => {
        if (field.includes('.')) {
            // Обновление вложенных полей (например, startPoint.weight)
            const [parent, child] = field.split('.');
            setUserData(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            // Обновление обычных полей
            setUserData(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    // Переход к следующему шагу
    const nextStep = () => {
        setCurrentStep(prev => prev + 1);
    };

    // Переход к предыдущему шагу
    const prevStep = () => {
        setCurrentStep(prev => prev - 1);
    };

    // Отправка данных на сервер
    const submitData = async () => {
        try {
            const initData = window.Telegram.WebApp.initData;
            await axios.post(`${config.API_BASE_URL}/profile/save`, {
                initData,
                userInfo: userData
            });

            // Перезагрузка страницы для обновления состояния isNew
            window.location.reload();
        } catch (error) {
            console.error('Ошибка при сохранении профиля:', error);
            // Можно добавить обработку ошибок
        }
    };

    // Отображение текущего шага
    const renderStep = () => {
        switch (currentStep) {
            case 0:
                return <WelcomePage onNext={nextStep} />;
            case 1:
                return (
                    <PersonalInfoPage
                        userData={userData}
                        updateUserData={updateUserData}
                        onNext={nextStep}
                        currentStep={currentStep}
                        totalSteps={5}
                    />
                );
            case 2:
                return (
                    <FitnessGoalPage
                        userData={userData}
                        updateUserData={updateUserData}
                        onNext={nextStep}
                        currentStep={currentStep}
                        totalSteps={5}
                    />
                );
            case 3:
                return (
                    <StartPointPage
                        userData={userData}
                        updateUserData={updateUserData}
                        onNext={nextStep}
                        currentStep={currentStep}
                        totalSteps={5}
                    />
                );
            case 4:
                return (
                    <TargetPointPage
                        userData={userData}
                        updateUserData={updateUserData}
                        onNext={nextStep}
                        currentStep={currentStep}
                        totalSteps={5}
                    />
                );
            case 5:
                return (
                    <SummaryPage
                        userData={userData}
                        onSubmit={submitData}
                        currentStep={currentStep}
                        totalSteps={5}
                    />
                );
            default:
                return <WelcomePage onNext={nextStep} />;
        }
    };

    return (
        <div className="onboarding-container">
            {renderStep()}
        </div>
    );
};

export default OnboardingFlow; 